const urlApiGroup = process.env.URL_API_GROUP || 'http://pharmedigroup-api.localhost:1080/api/v2/'

const SETTINGS = {
  dev: {
    urlApiGroup,
    mercureInternalUrl: 'http://localhost:17000/.well-known/mercure',
    tokenCron: 'g4i3E7tUgKw9Hn383gKQ',
    // Doit correspondre au PUBLIC_API_TOKEN du backend (dev/.env).
    publicApiToken: 'fjomUvZQOS9eov@ZhjFJ!$',
    googleId: 'G-27W21695Z3',
    googleTagManager: 'GTM-TFSD5B7',
    activateInternalSurvey: true,
    googleMapsApiKey: 'AIzaSyDf1IHAgULBdPNESsRQu4b5QbCmYUWvfXU',
    googleSsoClientId: '974772593309-e4qetlj229nduebb2i4btj84av0laobu.apps.googleusercontent.com',
    hotjar: {
      sv: 6,
      id: 1725515,
      debug: true,
    },
    ssoPharmUpp: {
      clientId: 'partner-pharmedisound',
      ssoUrl: 'https://auth.test.pharm-upp.fr/realms/Extranet/protocol/openid-connect/auth',
      callbackUrl:
        process.env.CALLBACK_URL_UPP || 'https://staging-extranet.pharmedigroup.com/sso_pharm_upp',
    },
    aiCoreUrl: process.env.AI_CORE_URL || 'http://localhost:3978',
    redirectUrlPharmedischoolBelgium:
      process.env.REDIRECT_URL_SCHOOL_BE || 'http://extranet-school-be.techexmachina.com',

  },
  staging: {
    urlApiGroup: 'https://staging-api.pharmedigroup.com/api/v2/',
    mercureInternalUrl: 'http://mercure/.well-known/mercure',
    tokenCron: 'g4i3E7tUgKw9Hn383gKQ',
    // Doit correspondre au PUBLIC_API_TOKEN du backend staging.
    publicApiToken: 'fjomUvZQOS9eov@ZhjFJ!$',
    googleId: 'G-27W21695Z3',
    googleTagManager: 'GTM-TFSD5B7',
    activateInternalSurvey: true,
    googleMapsApiKey: 'AIzaSyDf1IHAgULBdPNESsRQu4b5QbCmYUWvfXU',
    googleSsoClientId: '974772593309-e4qetlj229nduebb2i4btj84av0laobu.apps.googleusercontent.com',
    hotjar: {
      sv: 6,
      id: 6436164,
    },
    ssoPharmUpp: {
      clientId: 'partner-pharmedisound',
      ssoUrl: 'https://auth.test.pharm-upp.fr/realms/Extranet/protocol/openid-connect/auth',
      callbackUrl: 'https://staging-extranet.pharmedigroup.com/sso_pharm_upp',
    },
    aiCoreUrl: 'https://pharmedigroup-ai-core-staging.pharmedigroup.com',
    redirectUrlPharmedischoolBelgium: 'https://staging-extranet.pharmedischool.be/',

  },
  production: {
    urlApiGroup: 'https://api.pharmedigroup.com/api/v2/',
    mercureInternalUrl: 'http://mercure/.well-known/mercure',
    tokenCron: 'g4i3E7tUgKw9Hn383gKQ',
    // IMPORTANT: doit correspondre au PUBLIC_API_TOKEN du backend PROD (valeur a remplacer en prod).
    publicApiToken: 'fjomUvZQOS9eov@ZhjFJ!$',
    googleId: 'G-27W21695Z3',
    googleTagManager: 'GTM-TFSD5B7',
    activateInternalSurvey: false, //getDomainSetting('activateInternalSurvey')
    googleMapsApiKey: 'AIzaSyDf1IHAgULBdPNESsRQu4b5QbCmYUWvfXU',
    googleSsoClientId: '974772593309-e4qetlj229nduebb2i4btj84av0laobu.apps.googleusercontent.com',
    hotjar: {
      sv: 6,
      id: 6435988,
    },
    ssoPharmUpp: {
      clientId: 'partner-pharmedisound',
      ssoUrl: 'https://auth.pharm-upp.fr/realms/Extranet/protocol/openid-connect/auth',
      callbackUrl: 'https://extranet.pharmedigroup.com/sso_pharm_upp',
    },
    aiCoreUrl: 'https://pharmedigroup-ai-core.pharmedigroup.com',
    redirectUrlPharmedischoolBelgium: 'https://extranet.pharmedischool.be/',

  },
  firebaseConfig: {
    apiKey: 'AIzaSyCX1IUBfVd8-aQl_nvlJCO0TZVVjRvxU8w',
    authDomain: 'pharmedi-app.firebaseapp.com',
    projectId: 'pharmedi-app',
    storageBucket: 'pharmedi-app.appspot.com',
    messagingSenderId: '278918371165',
    appId: '1:278918371165:web:840dfcd90eeb08a4b8fab4',
    measurementId: 'G-8TRCC636YC',
  },

  /*
      This array contains the domains where the authentication is allowed.
      You can add subdomains or domains with wildcards.
      For example:
      - www.domain1.com
      - domain2.com
      - *.domain3.com
   */
  allowedAuthDomains: [
    'localhost:3877',
    '127.0.0.1:36223',
    '*.pharmedigroup.com',
    '*.pharmedigroup.be',
    '*.pharmedischool.be',
    '*.pharmedischool.fr',
    "*.monsuivipharma.com",
    "*.monsuivipharma.fr",
    '*.pharmedischool.com',
    '*.nanaland.ovh',
  ],
}

export default SETTINGS
